import React from 'react';
import { ContentTab, ContentTypes } from '@/types/util.types';

interface AuthorContentTabsProps {
  availableTabs: ContentTab[];
  activeTab: ContentTypes;
  handleTabChange: (tabId: ContentTypes) => void;
}

const AuthorContentTabs = ({ availableTabs, activeTab, handleTabChange }: AuthorContentTabsProps) => {
  return (
    <div>
      <ul className='flex flex-wrap gap-2' data-cy='author-content-tabs'>
        {availableTabs.map((tab) => (
          <li key={tab.id}>
            <button
              onClick={() => handleTabChange(tab.id)}
              className={`inline-flex items-center px-4 py-2 rounded-md transition-colors 
                ${
                  activeTab === tab.id
                    ? 'bg-gray-100 text-gray-700'
                    : 'hover:text-teal-600 hover:text-underline text-gray-600'
                }`}
              data-cy={`author-tab-${tab.id}`}
            >
              <span className='mr-2'>{tab.icon}</span>
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(AuthorContentTabs);
